<script setup lang="ts">
import paulo from '@/assets/paulo.webp'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'
import { Button } from '@/components/ui/button'
import { Title } from '@/components/ui/title'
</script>

<template>
    <section class="isolate mt-12 mb-12 flex flex-col justify-between gap-6 lg:mt-24 lg:mb-24 lg:flex-row">
        <div class="flex flex-col gap-6 sm:gap-8">
            <div>
                <Title>{{ $t('Frequently asked questions') }}</Title>
                <p class="font-inter mt-4">{{ $t('We have separated the main doubts') }}</p>
            </div>

            <div class="flex items-end gap-4">
                <div class="flex-1">
                    <img :src="paulo" loading="lazy" alt="" class="scale-x-[-1]" />
                </div>
                <div class="relative flex max-w-60 flex-col items-start gap-4">
                    <h4 class="text-sm font-semibold">{{ $t('Need some extra help? Talk to our team.') }}</h4>
                    <Button
                        as="a"
                        href="https://api.whatsapp.com/send/?phone=552134453000&text=Ol%C3%A1%21+Gostaria+de+mais+informa%C3%A7%C3%B5es+sobre+%20o+F%C3%B3rum+ILOS.&type=phone_number&app_absent=0"
                        target="_blank"
                        rel="noopener"
                        >{{ $t('Talk to us') }}</Button
                    >
                </div>
            </div>
        </div>

        <div class="w-full max-w-xl">
            <Accordion type="single" class="space-y-4">
                <AccordionItem value="1" class="rounded-[10px] bg-[#131518]">
                    <AccordionTrigger class="border-b border-transparent text-base font-semibold data-[state=open]:border-slate-800">{{
                        $t('What is the difference between Full Pass and Total Content?')
                    }}</AccordionTrigger>
                    <AccordionContent class="px-4 pt-4">
                        <div>
                            {{
                                $t(
                                    'A: Both tickets are in-person, but the Full Pass includes lunch on October 29th and 30th within the event venue. In addition to convenience, lunch is an excellent opportunity for networking.',
                                )
                            }}
                        </div>
                    </AccordionContent>
                </AccordionItem>
                <AccordionItem value="2" class="rounded-[10px] bg-[#131518]">
                    <AccordionTrigger class="border-b border-transparent text-base font-semibold data-[state=open]:border-slate-800">{{
                        $t('Is it possible to buy a ticket for just one day of the event?')
                    }}</AccordionTrigger>
                    <AccordionContent class="px-4 pt-4">
                        <div>{{ $t('A: No. Tickets are valid for access to both days of the event.') }}</div>
                    </AccordionContent>
                </AccordionItem>
                <AccordionItem value="3" class="rounded-[10px] bg-[#131518]">
                    <AccordionTrigger class="border-b border-transparent text-base font-semibold data-[state=open]:border-slate-800">{{
                        $t("I don't go every day, can I share the credential with a colleague?")
                    }}</AccordionTrigger>
                    <AccordionContent class="px-4 pt-4">
                        <div>{{ $t('A: No. Tickets are personal and non-transferable.') }}</div>
                    </AccordionContent>
                </AccordionItem>

                <AccordionItem value="4" class="rounded-[10px] bg-[#131518]">
                    <AccordionTrigger class="border-b border-transparent text-base font-semibold data-[state=open]:border-slate-800">{{
                        $t('What are the payment method options?')
                    }}</AccordionTrigger>
                    <AccordionContent class="px-4 pt-4">
                        <div>{{ $t('A: Payment can be made by credit card, pix, boleto and paypal.') }}</div>
                    </AccordionContent>
                </AccordionItem>

                <AccordionItem value="5" class="rounded-[10px] bg-[#131518]">
                    <AccordionTrigger class="border-b border-transparent text-base font-semibold data-[state=open]:border-slate-800">{{
                        $t('Can payment be made in installments?')
                    }}</AccordionTrigger>
                    <AccordionContent class="px-4 pt-4">
                        <div>
                            {{
                                $t(
                                    'A: Yes. Payment can be made in up to 3 interest-free installments on a credit card or in up to 12 interest-bearing installments. Installments are not valid for purchases made via Paypal.',
                                )
                            }}
                        </div>
                    </AccordionContent>
                </AccordionItem>
            </Accordion>
        </div>
    </section>
</template>
